import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Resets all applied and edited params (filters, search, pagination, sort)
 * when the collection context changes (e.g. switching between entities).
 * Also explicitly triggers a load so the new context is fetched with clean
 * params — even if all params were already at their defaults (in which case
 * queryRequest wouldn't emit a new value on its own).
 */
export const resetParamsOnContextChange = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.feature.selectors.context.asObservable.pipe(
      rxjsUtils.delayUntil(plugin.collection.ready$, { maxDelayed: 1 }),
      rxjs.skip(1),
      rxjs.mergeMap(() => [
        plugin.appliedParams.actions.writeAllProperties
          .from('resetParamsOnContextChange (effect)')
          .create({ values: {} }),
        plugin.editedParams.actions.writeAllProperties
          .from('resetParamsOnContextChange (effect)')
          .create({ values: {} }),
        feature.actions.load
          .from('resetParamsOnContextChange (effect)')
          .create(),
      ]),
    ),
)
